'use client';

import { useEffect, useState } from 'react';
import { dictionaryApi, type DictionaryItem } from '@/app/(modules)/robot-manager/_lib/api';
import { colors, typography } from '@/styles/theme';
import { Skeleton } from '@/components/ui/skeleton';
import { Badge, SimpleListPage } from '@/app/(modules)/robot-manager/_lib/SimpleListPage';
import { Button } from '@/components/ui/button';

const CATEGORY_LABELS: Record<string, string> = {
  label_type: '质量标签 (label_type)',
  tariff_type: '关税类型 (tariff_type)',
  declaration_type: '进口申报 (declaration_type)',
  service_issue_type: '售后问题 (service_issue_type)',
  industry: '行业 (industry)',
};

export default function DictionariesPage() {
  const [categories, setCategories] = useState<string[]>([]);
  const [active, setActive] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dictionaryApi
      .listCategories()
      .then((list) => {
        setCategories(list);
        if (list.length > 0 && !active) setActive(list[0]);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-full flex flex-col" style={{ backgroundColor: colors.bgSecondary }}>
      <div
        className="bg-white border-b px-6 h-12 flex items-center"
        style={{ borderColor: colors.border }}
      >
        <h1 className={typography.h4}>字典 / 参考数据</h1>
        <span className={`${typography.caption} ml-3`}>
          platform-master L1b · 跨模块复用的字典项（label_type / tariff_type / industry 等）
        </span>
      </div>

      <div
        className="bg-white border-b px-6 py-3 flex items-center gap-2 flex-wrap"
        style={{ borderColor: colors.border }}
      >
        {loading ? (
          <Skeleton className="h-8 w-64" />
        ) : (
          categories.map((cat) => (
            <Button
              key={cat}
              variant={active === cat ? 'default' : 'outline'}
              size="sm"
              onClick={() => setActive(cat)}
            >
              {CATEGORY_LABELS[cat] ?? cat}
            </Button>
          ))
        )}
      </div>

      <div className="flex-1 overflow-auto">
        {active && (
          <SimpleListPage<DictionaryItem>
            key={active}
            title={CATEGORY_LABELS[active] ?? active}
            description={`category = ${active}`}
            load={async () => dictionaryApi.listByCategory(active)}
            searchPlaceholder="客户端 search 暂不支持，刷新查全量"
            columns={[
              { key: 'code', label: 'Code', width: '180px' },
              { key: 'labelEn', label: 'Label (EN)' },
              { key: 'labelZh', label: 'Label (中)' },
              { key: 'sortOrder', label: '排序', width: '80px' },
              {
                key: 'enabled',
                label: '启用',
                width: '80px',
                render: (d) => (d.enabled ? '✓' : '✗'),
              },
              {
                key: 'metadata',
                label: 'Metadata',
                render: (d) =>
                  d.metadata && Object.keys(d.metadata).length > 0 ? (
                    <code className="text-xs">{JSON.stringify(d.metadata)}</code>
                  ) : (
                    '-'
                  ),
              },
            ]}
          />
        )}
      </div>
    </div>
  );
}
